import axios from 'common/utils/axios';
import { fileMetaData } from './types/file-metadata.type';

const filesApi = axios('files');

export const verifyImageMetaDataApi = (params: fileMetaData) => {
  return filesApi.get('verify', { params });
};
